<template>
  <!-- name: '捐赠/申领须知' -->
  <div class="noticeWrap">
    <div class="bgBox">
      <img src="https://img.bbalt.cn/imgh5/other/bg_notice.png" alt="" />
      <img src="https://img.bbalt.cn/imgh5/other/notice_arrow1.svg" alt="" />
    </div>
    <div class="btnBox">
      <div class="btnClass" @click="$router.push({ path: '/about', query: { code:'donateNotice' , title: '个人捐赠须知' } })">
        <h5>##想要捐赠必看##</h5>
        个人捐赠须知
        <img
          src="https://img.bbalt.cn/imgh5/other/icon_triangle_down.svg"
          alt=""
          class="downBtnClass"
        />
        <img
          src="https://img.bbalt.cn/imgh5/other/notice_donation.png"
          alt=""
          class="noticeImgClass"
        />
        <img src="https://img.bbalt.cn/imgh5/other/notice_arrow2.svg" alt="" />
      </div>
      <div class="btnClass" @click="$router.push({ path: '/apply', query: { code:'aboutUs' , title: '申领须知' } })">
        <h5>##申领物资必看##</h5>
        申领须知
        <img
          src="https://img.bbalt.cn/imgh5/other/icon_triangle_down.svg"
          alt=""
          class="downBtnClass"
        />
        <img
          src="https://img.bbalt.cn/imgh5/other/notice_application.svg"
          alt=""
          class="noticeImgClass"
        />
        <img src="https://img.bbalt.cn/imgh5/other/notice_line.svg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.noticeWrap {
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding-bottom: 37px;
  background-color: #fff;
  font-family: PingFangSC, PingFang SC;
  .bgBox {
    height: 376px;
    width: 100%;
    position: relative;
    img {
      &:first-child {
        width: 100%;
        height: 100%;
      }
      &:last-child {
        width: 40px;
        height: 72px;
        position: absolute;
        bottom: -34px;
        right: 58px;
      }
    }
  }
  .btnBox {
    display: flex;
    justify-content: space-between;
    margin: 56px 32px;

    .btnClass {
      width: 328px;
      height: 400px;
      background: #fbf7f4;
      border-radius: 16px;
      border: 1px solid #ffe9d9;
      font-size: 36px;
      font-weight: 600;
      color: #333333;
      line-height: 46px;
      text-align: center;
      display: flex;
      flex-flow: column;
      align-items: center;
      position: relative;
      h5 {
        background-repeat: no-repeat;
        background-size: 100% 52px;
        width: 100%;
        height: 52px;
        font-size: 26px;
        font-weight: 500;
        color: #ffffff;
        line-height: 52px;
        text-align: center;
        margin-bottom: 24px;
      }
      &:first-child {
        h5 {
          background-image: url("https://img.bbalt.cn/imgh5/other/notice_btn_bg1.svg");
        }
        img {
          &:last-child {
            width: 67px;
            height: 82px;
            position: absolute;
            bottom: 18px;
            left: -30px;
          }
        }
      }
      &:last-child {
        h5 {
          background-image: url("https://img.bbalt.cn/imgh5/other/notice_btn_bg2.svg");
        }
        img {
          &:last-child {
            width: 51px;
            height: 61px;
            position: absolute;
            bottom: -28px;
            left: 53px;
          }
        }
      }
      .downBtnClass {
        width: 20px;
        height: 20px;
        margin-top: 8px;
        margin-bottom: 14px;
      }
      .noticeImgClass {
        width: 202px;
        height: 202px;
      }
    }
  }
}
</style>
